import { render, staticRenderFns } from "./ModalDuplicate.vue?vue&type=template&id=62b92fe0&scoped=true"
import script from "./ModalDuplicate.vue?vue&type=script&lang=js"
export * from "./ModalDuplicate.vue?vue&type=script&lang=js"
import style0 from "./ModalDuplicate.vue?vue&type=style&index=0&id=62b92fe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b92fe0",
  null
  
)

export default component.exports